import React from 'react'
import { Route, Switch } from 'react-router-dom'

import Headings from '../components/Headings'
import Text from '../components/Text'
import Link from '../components/Link'

const Typography = (props: any) => {
  const { path } = props.match
  return (
      <Switch>
        <Route exact path={`${path}`} />
        <Route path={`${path}/headings`}>
          <Headings />
        </Route>
        <Route path={`${path}/Text`}>
          <Text />
        </Route>
        <Route path={`${path}/Links`}>
          <Link />
        </Route>
      </Switch>
  )
}

export default Typography
